"use strict";
exports.__esModule = true;
exports.ConfigurationApi = void 0;
var env_1 = require("../../env");
var api = {
    getCofigurationEngine: function (sessionId) { return env_1.Env.Endpoint + "/" + sessionId + "/configuration/engine"; },
    getCofigurationPlugin: function (sessionId) { return env_1.Env.Endpoint + "/" + sessionId + "/configuration/plugins"; }
};
exports.ConfigurationApi = api;
//# sourceMappingURL=configuration.api.js.map